import React, { useState, useEffect } from 'react';
import { Modal, ModalTitle, ModalContent, ModalFooter, TextInput, ComboBox, ComboBoxOption, Checkbox } from '@utahdts/utah-design-system';
import { Row, Col } from 'react-bootstrap';
import DwriSystemHeader from './sections/DwriSystemHeader';
import DwriManagementInfo from './sections/DwriManagementInfo';
import ButtonSubmit from '../../../reuseableComponents/buttons/ButtonSubmit';

const DwriCalculationsTab = ({ systemName, sizingInfo, assignableEngineers = [], loading = {}, errors = {} }) => {
    const user = sessionStorage.getItem("user")
        ? JSON.parse(sessionStorage.user)
        : JSON.parse(sessionStorage.defaultUser);

    const canEditWaterSystemInfo = user?.permissions?.includes("edit_water_use_system_info");

    const [showEditModal, setShowEditModal] = useState(false);
    const [cca, setCca] = useState(false);
    const [pwsEngineerReport, setPwsEngineerReport] = useState(false);
    const [assignedTo, setAssignedTo] = useState('');
    const [pwsFileNumber, setPwsFileNumber] = useState('');
    const [d2Link, setD2Link] = useState('');

    useEffect(() => {
        if (sizingInfo) {
            setCca(!!sizingInfo.ccaDate);
            setPwsEngineerReport(sizingInfo.engReport === 'Yes');
            setAssignedTo(sizingInfo.engineerName || '');
            setPwsFileNumber(sizingInfo.fileNumber || '');
            setD2Link(sizingInfo.d2Link || '');
        }
    }, [sizingInfo]);

    const assignedToOptions = assignableEngineers
        .map((engineer) => {
            const firstName = engineer?.firstName?.trim() || '';
            const lastName = engineer?.lastName?.trim() || '';
            const fullName = [lastName, firstName].filter(Boolean).join(', ');

            return {
                key: engineer?.umdId || fullName,
                value: fullName,
            };
        })
        .filter((option) => option.value);

    return (
        <div className="utah-design-system">
            <DwriSystemHeader
                systemName={systemName}
                loading={loading.info}
            />
            {canEditWaterSystemInfo && (
                <button
                    className="fake-link"
                    style={{ background: 'none', border: 'none', padding: 0 }}
                    onClick={() => setShowEditModal(true)}
                >Edit</button>
            )}
            <DwriManagementInfo
                sizingInfo={sizingInfo}
                loading={loading.info}
                error={errors.info}
            />
            {showEditModal && (
                <Modal
                    className="modal--medium"
                    onClose={() => setShowEditModal(false)}
                    onEscape={() => setShowEditModal(false)}
                >
                    <ModalTitle>Manage Water System Information</ModalTitle>
                    <ModalContent id="manage-water-system-modal-content">
                        <Row className="mb-3">
                            <Col xs={4}>
                                <ComboBox
                                    id="assignedTo"
                                    label="Assigned To"
                                    name="assignedTo"
                                    value={assignedTo}
                                    onChange={(value) => setAssignedTo(value)}
                                >
                                    {assignedToOptions.map((engineer) => (
                                        <ComboBoxOption
                                            key={engineer.key}
                                            label={engineer.value}
                                            value={engineer.value}
                                        />
                                    ))}
                                </ComboBox>
                            </Col>
                            <Col xs={4}>
                                <Checkbox
                                    id="cca"
                                    label="CCA"
                                    name="cca"
                                    value={cca}
                                    onChange={(e) => setCca(e.target.checked)}
                                    wrapperClassName="checkbox-label-top"
                                />
                            </Col>
                            <Col xs={4}>
                                <Checkbox
                                    id="pwsEngineerReport"
                                    label="PWS Engineer Report"
                                    name="pwsEngineerReport"
                                    value={pwsEngineerReport}
                                    onChange={(e) => setPwsEngineerReport(e.target.checked)}
                                    wrapperClassName="checkbox-label-top"
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col>
                                <TextInput
                                    id="pwsFileNumber"
                                    label="PWS File Number"
                                    name="pwsFileNumber"
                                    value={pwsFileNumber}
                                    onChange={(e) => setPwsFileNumber(e.target.value)}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col>
                                <TextInput
                                    id="d2Link"
                                    label="D2 Link"
                                    name="d2Link"
                                    value={d2Link}
                                    onChange={(e) => setD2Link(e.target.value)}
                                />
                            </Col>
                        </Row>
                    </ModalContent>
                    <ModalFooter id="manage-water-system-modal-footer">
                        <div className="d-flex justify-content-end">
                            <ButtonSubmit id="ddw-primary" label="Save" onClick={() => setShowEditModal(false)} />
                        </div>
                    </ModalFooter>
                </Modal>
            )}
        </div>
    );
};

export default DwriCalculationsTab;